import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Pagination } from '../../../../../common/pagination/pagination.model';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-emails-pagination',
  standalone: true,
  imports: [FormsModule, TranslateModule],
  templateUrl: './emails-pagination.component.html',
  styleUrl: './emails-pagination.component.scss',
})
export class EmailsPaginationComponent {
  @Input() pagination: any;
  @Input() hasNextPage: any;
  @Output() pageChanged = new EventEmitter<number>();
  @Output() perPageChanged = new EventEmitter<number>();

  onPageChange(page: number) {
    if (page >= 1) {
      this.pageChanged.emit(page);
    }
  }

  onPerPageChange(event: any) {
    const perPage = parseInt(event.target.value);
    this.perPageChanged.emit(perPage);
  }
}
